<template>
  <div
    v-if="overview360Info"
    class="overview-360"
    ref="overview"
    @touchend="isActive = false"
    @mouseleave="isActive = false"
    @touchmove="startMouseMove"
    @mousemove="startMouseMove"
    @touchstart="handleMouseDown"
    @mousedown="handleMouseDown"
    @click="isActive = false"
    @dragstart.prevent
  >
    <img
      class="overview-360__image"
      v-for="(photo, i) in overview360Info.photos"
      :class="{ 'overview-360__image--visible': +i === currentPhotoIndex }"
      :src="photo.desktop_photo_url"
      @load="imageLoadedCallback"
      alt="360"
      :key="i"
    />
    <Loader :isLoading="isLoading" />
  </div>
</template>

<script>
import { debounce } from '../../../mixins'
import { mapState } from 'vuex'
import throttle from '@/helpers/throttle'
import Loader from '@/components/helpers/Loader'

export default {
  name: 'Overview',
  mixins: [debounce],
  components: {
    Loader
  },
  data () {
    return {
      lastX: 0,
      currentPhotoIndex: 0,
      isActive: false,
      loadedImagesCount: 0,
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      productId: state => state.productInfo.productInfo.productId,
      overview360Info: state => state.productGallery.overview360
    })
  },
  methods: {
    startMouseMove (event) {
      if (this.isActive) {
        this.mouseMoveHandler(event)
      }
    },
    handleMouseDown () {
      this.isActive = true
      this.lastX = 0
    },
    mouseMoveHandler: throttle(function (e) {
      const currentX = e.touches ? e.touches[0].clientX : e.x
      if (currentX && currentX > this.lastX + 5) {
        if (this.lastX) this.currentPhotoIndex++
        this.lastX = currentX
      } else if (currentX && currentX < this.lastX - 5) {
        if (this.lastX) this.currentPhotoIndex--
        this.lastX = currentX
      }

      if (this.currentPhotoIndex > this.overview360Info.amount - 1) {
        this.currentPhotoIndex = 0
      } else if (this.currentPhotoIndex < 0) {
        this.currentPhotoIndex = this.overview360Info.amount - 1
      }
    }, 20),
    imageLoadedCallback () {
      this.loadedImagesCount++
      if (this.loadedImagesCount === this.overview360Info.amount) {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.overview-360
  max-height: 70vh
  max-width: initial
  cursor: url(/img/overview360.png), move

  +mmin(1100)
    max-width: 100%
    max-height: 600px

.overview-360__image
  display: none
  -webkit-user-drag: none
  max-height: 50vh
  touch-action: none
  pointer-events: none
  user-select: none

  +mmin(1100)
    max-height: 600px

  &--visible
    display: block
</style>
